// import React, { useState, useEffect } from 'react';
// import { FiMenu, FiPlus, FiMessageSquare, FiTrash2, FiSend, FiUser, FiLogOut, FiPenTool, FiBookOpen, FiCode, FiCoffee, FiZap } from 'react-icons/fi';
// import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const AITopicGenerator = () => {
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [chats, setChats] = useState([
//     { id: 1, title: 'New Chat', messages: [] }
//   ]);
//   const [activeChat, setActiveChat] = useState(1);
//   const [inputMessage, setInputMessage] = useState('');
//   const [isTyping, setIsTyping] = useState(false);
//   const [user, setUser] = useState(null);
//   const [showProfileMenu, setShowProfileMenu] = useState(false);

//   // Simulated Google Login
//   const handleGoogleLogin = () => {
//     // In real app, implement Google OAuth
//     const mockUser = {
//       name: 'Mahesh Kumar',
//       email: 'mahesh@example.com',
//       picture: 'https://ui-avatars.com/api/?name=Mahesh+Kumar&background=ff6b35&color=fff&size=128'
//     };
//     setUser(mockUser);
//   };

//   const handleLogout = () => {
//     setUser(null);
//     setShowProfileMenu(false);
//     setChats([{ id: 1, title: 'New Chat', messages: [] }]);
//     setActiveChat(1);
//   };

//   const toggleSidebar = () => {
//     setSidebarCollapsed(!sidebarCollapsed);
//   };

//   const createNewChat = () => {
//     const newChat = {
//       id: Date.now(),
//       title: 'New Chat',
//       messages: []
//     };
//     setChats([newChat, ...chats]);
//     setActiveChat(newChat.id);
//   };

//   const deleteChat = (id) => {
//     if (chats.length === 1) return;
//     const filtered = chats.filter(chat => chat.id !== id);
//     setChats(filtered);
//     if (activeChat === id) {
//       setActiveChat(filtered[0].id);
//     }
//   };

//   const sendMessage = async () => {
//     if (!inputMessage.trim() || !user) return;

//     const userMessage = {
//       id: Date.now(),
//       text: inputMessage,
//       sender: 'user',
//       timestamp: new Date()
//     };

//     setChats(chats.map(chat => {
//       if (chat.id === activeChat) {
//         const updatedMessages = [...chat.messages, userMessage];
//         const newTitle = chat.messages.length === 0 
//           ? inputMessage.slice(0, 30) + (inputMessage.length > 30 ? '...' : '')
//           : chat.title;
//         return { ...chat, messages: updatedMessages, title: newTitle };
//       }
//       return chat;
//     }));

//     setInputMessage('');
//     setIsTyping(true);

//     // Simulate AI response for topic generation
//     setTimeout(() => {
//       const aiMessage = {
//         id: Date.now() + 1,
//         text: generateTopicResponse(userMessage.text),
//         sender: 'ai',
//         timestamp: new Date()
//       };

//       setChats(chats.map(chat => {
//         if (chat.id === activeChat) {
//           return { ...chat, messages: [...chat.messages, userMessage, aiMessage] };
//         }
//         return chat;
//       }));
//       setIsTyping(false);
//     }, 1500);
//   };

//   const generateTopicResponse = (userInput) => {
//     const topics = [
//       `Based on "${userInput}", here are some engaging topics:\n\n1. Understanding the fundamentals and core concepts\n2. Advanced techniques and best practices\n3. Real-world applications and case studies\n4. Common challenges and how to overcome them\n5. Future trends and innovations in this area`,
//       `Great topic! Here are some interesting angles to explore:\n\n• Historical perspective and evolution\n• Current state and key developments\n• Practical implementation strategies\n• Expert insights and recommendations\n• Emerging opportunities and potential`,
//       `Excellent choice! Let me suggest these topic ideas:\n\n→ Introduction and foundational knowledge\n→ Detailed analysis and deep dive\n→ Comparison with alternatives\n→ Step-by-step guides and tutorials\n→ Success stories and lessons learned`
//     ];
//     return topics[Math.floor(Math.random() * topics.length)];
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       sendMessage();
//     }
//   };

//   const quickActions = [
//     { icon: <FiPenTool size={18} />, label: 'Write', color: '#ff6b35' },
//     { icon: <FiBookOpen size={18} />, label: 'Learn', color: '#4ecdc4' },
//     { icon: <FiCode size={18} />, label: 'Code', color: '#95e1d3' },
//     { icon: <FiCoffee size={18} />, label: 'Life stuff', color: '#f38181' },
//     { icon: <FiZap size={18} />, label: "AI's choice", color: '#aa96da' }
//   ];

//   const currentChat = chats.find(chat => chat.id === activeChat);
//   const userName = user?.name?.split(' ')[0] || 'Guest';

//   return (
//     <div style={{ display: 'flex', height: '90vh', overflow: 'hidden', background: '#1a1a1a' , marginTop:'90px', position: 'relative'}}>
//       {/* Sidebar */}
//       <div 
//         style={{
//           width: sidebarCollapsed ? '60px' : '260px',
//           background: '#2d2d2d',
//           color: '#e0e0e0',
//           transition: 'width 0.3s ease',
//           display: 'flex',
//           flexDirection: 'column',
//           borderRight: '1px solid #3d3d3d'
//         }}
//       >
//         {/* Sidebar Header */}
//         <div style={{ padding: '15px', borderBottom: '1px solid #3d3d3d' }}>
//           <button 
//             className="btn w-100 d-flex align-items-center justify-content-center"
//             onClick={createNewChat}
//             disabled={!user}
//             style={{ 
//               gap: '8px',
//               background: '#ff6b35',
//               color: 'white',
//               border: 'none',
//               borderRadius: '8px',
//               padding: '10px',
//               opacity: user ? 1 : 0.5
//             }}
//           >
//             <FiPlus size={20} />
//             {!sidebarCollapsed && <span>New Chat</span>}
//           </button>
//         </div>

//         {/* Chat List */}
//         <div style={{ flex: 1, overflowY: 'auto', padding: '10px' }}>
//           {user && chats.map(chat => (
//             <div
//               key={chat.id}
//               onClick={() => setActiveChat(chat.id)}
//               style={{
//                 padding: sidebarCollapsed ? '12px 8px' : '12px',
//                 marginBottom: '5px',
//                 background: activeChat === chat.id ? '#3d3d3d' : 'transparent',
//                 borderRadius: '8px',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '10px',
//                 transition: 'background 0.2s'
//               }}
//               onMouseEnter={(e) => {
//                 if (activeChat !== chat.id) e.currentTarget.style.background = '#353535';
//               }}
//               onMouseLeave={(e) => {
//                 if (activeChat !== chat.id) e.currentTarget.style.background = 'transparent';
//               }}
//             >
//               <FiMessageSquare size={18} style={{ flexShrink: 0, color: '#b0b0b0' }} />
//               {!sidebarCollapsed && (
//                 <>
//                   <span style={{ 
//                     flex: 1, 
//                     overflow: 'hidden', 
//                     textOverflow: 'ellipsis', 
//                     whiteSpace: 'nowrap',
//                     fontSize: '14px',
//                     color: '#e0e0e0'
//                   }}>
//                     {chat.title}
//                   </span>
//                   {chats.length > 1 && (
//                     <button
//                       className="btn btn-sm btn-link p-0"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         deleteChat(chat.id);
//                       }}
//                       style={{ color: '#8d8d8d' }}
//                     >
//                       <FiTrash2 size={14} />
//                     </button>
//                   )}
//                 </>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Toggle Button */}
//         <div style={{ padding: '15px', borderTop: '1px solid #3d3d3d' }}>
//           <button 
//             className="btn w-100 d-flex align-items-center justify-content-center"
//             onClick={toggleSidebar}
//             style={{ background: '#3d3d3d', color: '#e0e0e0', border: 'none' }}
//           >
//             {sidebarCollapsed ? <BiChevronRight size={20} /> : <BiChevronLeft size={20} />}
//           </button>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//         {/* Header */}
//         <div 
//           style={{
//             padding: '15px 20px',
//             background: '#2d2d2d',
//             borderBottom: '1px solid #3d3d3d',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between'
//           }}
//         >
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <FiMenu size={24} style={{ color: '#b0b0b0', cursor: 'pointer' }} onClick={toggleSidebar} />
//           </div>
          
//           <div style={{ position: 'relative' }}>
//             {user ? (
//               <>
//                 <div 
//                   onClick={() => setShowProfileMenu(!showProfileMenu)}
//                   style={{ 
//                     display: 'flex', 
//                     alignItems: 'center', 
//                     gap: '10px', 
//                     cursor: 'pointer',
//                     padding: '5px 10px',
//                     borderRadius: '20px',
//                     background: showProfileMenu ? '#3d3d3d' : 'transparent'
//                   }}
//                 >
//                   <img 
//                     src={user.picture} 
//                     alt={user.name}
//                     style={{ 
//                       width: '32px', 
//                       height: '32px', 
//                       borderRadius: '50%' 
//                     }}
//                   />
//                   <span style={{ color: '#e0e0e0', fontSize: '14px' }}>{user.name}</span>
//                 </div>
                
//                 {showProfileMenu && (
//                   <div style={{
//                     position: 'absolute',
//                     right: 0,
//                     top: '45px',
//                     background: '#2d2d2d',
//                     border: '1px solid #3d3d3d',
//                     borderRadius: '8px',
//                     padding: '10px',
//                     minWidth: '200px',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
//                     zIndex: 1000
//                   }}>
//                     <div style={{ padding: '10px', borderBottom: '1px solid #3d3d3d' }}>
//                       <div style={{ color: '#e0e0e0', fontWeight: 'bold' }}>{user.name}</div>
//                       <div style={{ color: '#8d8d8d', fontSize: '12px' }}>{user.email}</div>
//                     </div>
//                     <button
//                       onClick={handleLogout}
//                       className="btn w-100 text-start mt-2"
//                       style={{ 
//                         color: '#ff6b35', 
//                         background: 'transparent',
//                         border: 'none',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px'
//                       }}
//                     >
//                       <FiLogOut size={18} />
//                       Logout
//                     </button>
//                   </div>
//                 )}
//               </>
//             ) : (
//               <button
//                 onClick={handleGoogleLogin}
//                 className="btn"
//                 style={{
//                   background: '#ff6b35',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '8px',
//                   padding: '8px 16px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '8px'
//                 }}
//               >
//                 <FiUser size={18} />
//                 Login with Google
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Chat Messages */}
//         <div 
//           style={{ 
//             flex: 1, 
//             overflowY: 'auto', 
//             padding: '40px 20px',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center'
//           }}
//         >
//           {!user ? (
//             <div style={{ 
//               maxWidth: '600px',
//               textAlign: 'center',
//               marginTop: '100px'
//             }}>
//               <div style={{ 
//                 fontSize: '48px',
//                 marginBottom: '20px'
//               }}>
//                 ✨
//               </div>
//               <h2 style={{ color: '#e0e0e0', marginBottom: '15px' }}>Welcome to AI Topic Generator</h2>
//               <p style={{ color: '#8d8d8d', marginBottom: '30px' }}>
//                 Please login with your Google account to start generating amazing topics
//               </p>
//               <button
//                 onClick={handleGoogleLogin}
//                 className="btn btn-lg"
//                 style={{
//                   background: '#ff6b35',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '12px',
//                   padding: '12px 32px',
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   gap: '10px'
//                 }}
//               >
//                 <FiUser size={20} />
//                 Login with Google
//               </button>
//             </div>
//           ) : currentChat?.messages.length === 0 ? (
//             <div style={{ 
//               maxWidth: '700px',
//               width: '100%',
//               textAlign: 'center'
//             }}>
//               <div style={{ 
//                 fontSize: '48px',
//                 marginBottom: '20px'
//               }}>
//                 ✨
//               </div>
//               <h2 style={{ 
//                 color: '#e0e0e0', 
//                 marginBottom: '10px',
//                 fontSize: '32px'
//               }}>
//                 What's new, {userName}?
//               </h2>
//               <p style={{ color: '#8d8d8d', marginBottom: '40px', fontSize: '16px' }}>
//                 Ask me to generate topics on any subject you're interested in
//               </p>
              
//               {/* Quick Actions */}
//               <div style={{ 
//                 display: 'flex', 
//                 gap: '10px', 
//                 justifyContent: 'center',
//                 flexWrap: 'wrap',
//                 marginTop: '40px'
//               }}>
//                 {quickActions.map((action, idx) => (
//                   <button
//                     key={idx}
//                     className="btn"
//                     style={{
//                       background: '#3d3d3d',
//                       color: '#e0e0e0',
//                       border: `2px solid ${action.color}`,
//                       borderRadius: '20px',
//                       padding: '10px 20px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '8px',
//                       transition: 'all 0.2s'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = action.color;
//                       e.currentTarget.style.transform = 'translateY(-2px)';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = '#3d3d3d';
//                       e.currentTarget.style.transform = 'translateY(0)';
//                     }}
//                   >
//                     {action.icon}
//                     {action.label}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div style={{ maxWidth: '800px', width: '100%' }}>
//               {currentChat?.messages.map(message => (
//                 <div
//                   key={message.id}
//                   style={{
//                     display: 'flex',
//                     gap: '15px',
//                     padding: '20px',
//                     marginBottom: '15px',
//                     background: message.sender === 'user' ? '#2d2d2d' : '#3d3d3d',
//                     borderRadius: '12px',
//                     border: '1px solid #4d4d4d'
//                   }}
//                 >
//                   <div style={{
//                     width: '36px',
//                     height: '36px',
//                     borderRadius: '50%',
//                     background: message.sender === 'user' ? '#ff6b35' : '#4ecdc4',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: 'white',
//                     flexShrink: 0,
//                     fontWeight: 'bold'
//                   }}>
//                     {message.sender === 'user' ? user.name.charAt(0) : 'AI'}
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <p style={{ margin: 0, lineHeight: '1.6', color: '#e0e0e0', whiteSpace: 'pre-line' }}>
//                       {message.text}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//               {isTyping && (
//                 <div style={{
//                   display: 'flex',
//                   gap: '15px',
//                   padding: '20px',
//                   background: '#3d3d3d',
//                   borderRadius: '12px',
//                   border: '1px solid #4d4d4d'
//                 }}>
//                   <div style={{
//                     width: '36px',
//                     height: '36px',
//                     borderRadius: '50%',
//                     background: '#4ecdc4',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: 'white',
//                     flexShrink: 0,
//                     fontWeight: 'bold'
//                   }}>
//                     AI
//                   </div>
//                   <div style={{ flex: 1, color: '#b0b0b0' }}>
//                     <span>Generating topics...</span>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* Input Area */}
//         {user && (
//           <div style={{ 
//             padding: '20px', 
//             background: '#2d2d2d', 
//             borderTop: '1px solid #3d3d3d' 
//           }}>
//             <div style={{ 
//               maxWidth: '800px', 
//               margin: '0 auto',
//               background: '#1a1a1a',
//               borderRadius: '12px',
//               border: '1px solid #3d3d3d',
//               padding: '10px'
//             }}>
//               <textarea
//                 className="form-control"
//                 placeholder="How can I help you today?"
//                 value={inputMessage}
//                 onChange={(e) => setInputMessage(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 rows={1}
//                 style={{ 
//                   resize: 'none',
//                   minHeight: '50px',
//                   maxHeight: '150px',
//                   background: 'transparent',
//                   border: 'none',
//                   color: '#e0e0e0',
//                   outline: 'none'
//                 }}
//               />
//               <div style={{ 
//                 display: 'flex', 
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginTop: '10px'
//               }}>
//                 <div style={{ display: 'flex', gap: '10px' }}>
//                   <button className="btn btn-sm" style={{ background: 'transparent', border: 'none', color: '#8d8d8d' }}>
//                     <FiPlus size={18} />
//                   </button>
//                 </div>
//                 <button 
//                   className="btn"
//                   onClick={sendMessage}
//                   disabled={!inputMessage.trim()}
//                   style={{
//                     background: inputMessage.trim() ? '#ff6b35' : '#3d3d3d',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     padding: '8px 16px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px'
//                   }}
//                 >
//                   <FiSend size={16} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AITopicGenerator;


import React, { useState, useEffect, useRef } from 'react';
import { FiMenu, FiPlus, FiMessageSquare, FiTrash2, FiSend, FiUser, FiLogOut, FiPenTool, FiBookOpen, FiCode, FiCoffee, FiZap, FiChevronLeft, FiChevronRight, FiSidebar, FiChevronsLeft } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';

// ============================================
// FIREBASE CONFIGURATION
// ============================================

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
    authDomain: "olewin-academy.firebaseapp.com",
    projectId: "olewin-academy",
    storageBucket: "olewin-academy.appspot.com",
    messagingSenderId: "622543323365",
    appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
    measurementId: "G-09WHHRMJRC"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const AITopicGenerator = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [chats, setChats] = useState([
    { id: 1, title: 'New Chat', messages: [] }
  ]);
  const [activeChat, setActiveChat] = useState(1);
  const [inputMessage, setInputMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [user, setUser] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const messagesEndRef = useRef(null);

  // ============================================
  // FIREBASE AUTHENTICATION FUNCTIONS
  // ============================================
  
  // Initialize Firebase Auth Listener
  useEffect(() => {
    // Uncomment when Firebase is configured
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser({
          uid: currentUser.uid,
          name: currentUser.displayName,
          email: currentUser.email,
          picture: currentUser.photoURL
        });
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  // Google Sign In
  const handleGoogleLogin = async () => {
    try {
      // Uncomment when Firebase is configured
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      setUser({
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        picture: user.photoURL
      });
      
      // MOCK LOGIN FOR DEMO - Remove this in production
    //   const mockUser = {
    //     uid: 'demo-user-123',
    //     name: 'Mahesh Kumar',
    //     email: 'mahesh@example.com',
    //     picture: 'https://ui-avatars.com/api/?name=Mahesh+Kumar&background=ff6b35&color=fff&size=128'
    //   };
      setUser();
      
    } catch (error) {
      console.error('Login Error:', error);
      alert('Login failed. Please try again.');
    }
  };

  // Logout
  const handleLogout = async () => {
    try {
      // Uncomment when Firebase is configured
      await signOut(auth);
      
      // MOCK LOGOUT FOR DEMO
      setUser(null);
      setShowProfileMenu(false);
      setChats([{ id: 1, title: 'New Chat', messages: [] }]);
      setActiveChat(1);
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  // ============================================
  // API INTEGRATION FUNCTIONS
  // ============================================
  
  // Call your backend API
  const callBackendAPI = async (userMessage) => {
    try {
      // Replace with your actual API endpoint
      const API_ENDPOINT = 'https://your-backend-api.com/generate-topics';
      
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.uid}`, // Send user token if needed
        },
        body: JSON.stringify({
          prompt: userMessage,
          userId: user.uid,
          chatId: activeChat
        })
      });

      if (!response.ok) {
        throw new Error('API request failed');
      }

      const data = await response.json();
      return data.response || data.message || data.content;
      
    } catch (error) {
      console.error('API Error:', error);
      // Fallback to mock response if API fails
      return generateMockTopicResponse(userMessage);
    }
  };
  // Add to the component
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
    if (window.innerWidth < 768) {
      setSidebarCollapsed(true);
    }
  };
  
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

const sendMessageWithStreaming = async () => {
  if (!inputMessage.trim() || !user) return;

  const userMessage = { 
    id: Date.now(), 
    text: inputMessage, 
    sender: 'user', 
    timestamp: new Date() 
  };

  setChats(prev => prev.map(chat => 
    chat.id === activeChat 
      ? { ...chat, messages: [...chat.messages, userMessage] }
      : chat
  ));

  setInputMessage('');
  setIsTyping(true);

  try {
    const response = await fetch('https://your-api.com/api/stream', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.uid}`,
      },
      body: JSON.stringify({ prompt: userMessage.text })
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let aiText = '';

    const aiMessage = {
      id: Date.now() + 1,
      text: '',
      sender: 'ai',
      timestamp: new Date()
    };

    setChats(prev => prev.map(chat =>
      chat.id === activeChat
        ? { ...chat, messages: [...chat.messages, aiMessage] }
        : chat
    ));

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      //aiText += decoder.decode(value);
      
      setChats(prev => prev.map(chat =>
        chat.id === activeChat
          ? {
              ...chat,
              messages: chat.messages.map(msg =>
                msg.id === aiMessage.id ? { ...msg, text: aiText } : msg
              )
            }
          : chat
      ));
    }

    setIsTyping(false);
  } catch (error) {
    console.error('Streaming error:', error);
    setIsTyping(false);
  }
};
const loadUserChats = async () => {
  try {
    const response = await fetch(
      `https://your-api.com/api/chats?userId=${user.uid}`,
      {
        headers: {
          'Authorization': `Bearer ${user.uid}`,
        }
      }
    );
    const data = await response.json();
    setChats(data.chats || [{ id: 1, title: 'New Chat', messages: [] }]);
  } catch (error) {
    console.error('Load chats error:', error);
  }
};

// Call when user logs in
useEffect(() => {
  if (user) {
    loadUserChats();
  }
}, [user]);

const saveChatToBackend = async (chatId, messages) => {
  try {
    await fetch('https://your-api.com/api/save-chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.uid}`,
      },
      body: JSON.stringify({
        chatId,
        userId: user.uid,
        messages,
        timestamp: new Date()
      })
    });
  } catch (error) {
    console.error('Save error:', error);
  }
};

// Call this after each message exchange
useEffect(() => {
  if (user && currentChat?.messages.length > 0) {
    saveChatToBackend(activeChat, currentChat.messages);
  }
}, [chats]);


  // Mock response generator (fallback)
  const generateMockTopicResponse = (userInput) => {
    const topics = [
      `Based on "${userInput}", here are some engaging topics:\n\n1. Understanding the fundamentals and core concepts\n2. Advanced techniques and best practices\n3. Real-world applications and case studies\n4. Common challenges and how to overcome them\n5. Future trends and innovations in this area`,
      `Great topic! Here are some interesting angles to explore:\n\n• Historical perspective and evolution\n• Current state and key developments\n• Practical implementation strategies\n• Expert insights and recommendations\n• Emerging opportunities and potential`,
      `Excellent choice! Let me suggest these topic ideas:\n\n→ Introduction and foundational knowledge\n→ Detailed analysis and deep dive\n→ Comparison with alternatives\n→ Step-by-step guides and tutorials\n→ Success stories and lessons learned`
    ];
    return topics[Math.floor(Math.random() * topics.length)];
  };

  
  // ============================================
  // CHAT FUNCTIONS
  // ============================================
  

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const createNewChat = () => {
    const newChat = {
      id: Date.now(),
      title: 'New Chat',
      messages: []
    };
    setChats([newChat, ...chats]);
    setActiveChat(newChat.id);
  };

  const deleteChat = (id) => {
    if (chats.length === 1) return;
    const filtered = chats.filter(chat => chat.id !== id);
    setChats(filtered);
    if (activeChat === id) {
      setActiveChat(filtered[0].id);
    }
  };

  const sendMessage = async () => {
    if (!inputMessage.trim() || !user) return;

    const userMessage = {
      id: Date.now(),
      text: inputMessage,
      sender: 'user',
      timestamp: new Date()
    };

    // Update chat with user message
    setChats(prevChats => prevChats.map(chat => {
      if (chat.id === activeChat) {
        const updatedMessages = [...chat.messages, userMessage];
        const newTitle = chat.messages.length === 0 
          ? inputMessage.slice(0, 30) + (inputMessage.length > 30 ? '...' : '')
          : chat.title;
        return { ...chat, messages: updatedMessages, title: newTitle };
      }
      return chat;
    }));

    setInputMessage('');
    setIsTyping(true);

    // Call backend API
    try {
      const aiResponseText = await callBackendAPI(userMessage.text);
      
      const aiMessage = {
        id: Date.now() + 1,
        text: aiResponseText,
        sender: 'ai',
        timestamp: new Date()
      };

      setChats(prevChats => prevChats.map(chat => {
        if (chat.id === activeChat) {
          return { ...chat, messages: [...chat.messages, aiMessage] };
        }
        return chat;
      }));
      
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMessage = {
        id: Date.now() + 1,
        text: 'Sorry, I encountered an error. Please try again.',
        sender: 'ai',
        timestamp: new Date()
      };
      setChats(prevChats => prevChats.map(chat => {
        if (chat.id === activeChat) {
          return { ...chat, messages: [...chat.messages, errorMessage] };
        }
        return chat;
      }));
    } finally {
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  // Auto scroll to bottom
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chats, isTyping]);

  const quickActions = [
    { icon: <FiPenTool size={18} />, label: 'Write', color: '#ff6b35' },
    { icon: <FiBookOpen size={18} />, label: 'Learn', color: '#4ecdc4' },
    { icon: <FiCode size={18} />, label: 'Code', color: '#95e1d3' },
    { icon: <FiCoffee size={18} />, label: 'Life stuff', color: '#f38181' },
    { icon: <FiZap size={18} />, label: "AI's choice", color: '#aa96da' }
  ];

  const currentChat = chats.find(chat => chat.id === activeChat);
  const userName = user?.name?.split(' ')[0] || 'Guest';

  return (
    <div style={{ display: 'flex', height: '90vh', padding:'20px', overflow: 'hidden', background: '#1a1a1a', marginTop:'90px', position:'relative' }}>
      {/* Sidebar */}
      <div 
        style={{
          width: sidebarCollapsed ? '60px' : '280px',
          background: '#00000079',
          color: '#e0e0e0',
          transition: 'width 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          borderRight: '1px solid #3d3d3d'
        }}
      >
        {/* Sidebar Header with Toggle */}
        <div style={{ 
          padding: '15px', 
          borderBottom: '1px solid #3d3d3d',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          {!sidebarCollapsed && (
            <span style={{ fontSize: '16px', fontWeight: '600', color: '#e0e0e0' }}>
              Chats
            </span>
          )}
          <button 
            className="btn btn-sm p-0"
            onClick={toggleSidebar}
            style={{ 
              background: 'transparent',
              border: 'none',
              color: '#b0b0b0',
              marginLeft: sidebarCollapsed ? 'auto' : '0',
              marginRight: sidebarCollapsed ? 'auto' : '0'
            }}
          >
            {sidebarCollapsed ? <FiSidebar size={25} /> : <FiChevronsLeft size={25} />}
          </button>
        </div>

        {/* New Chat Button */}
        <div style={{ padding: '15px', borderBottom: '1px solid #3d3d3d' }}>
          <button 
            className="btn w-100 d-flex align-items-center justify-content-center"
            onClick={createNewChat}
            disabled={!user}
            style={{ 
              gap: '8px',
              background: '#58A95B',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '10px',
              opacity: user ? 1 : 0.5,
              cursor: user ? 'pointer' : 'not-allowed'
            }}
          >
            <FiPlus size={20} />
            {!sidebarCollapsed && <span>New Chat</span>}
          </button>
        </div>

        {/* Chat List */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px' }}>
          {user && chats.map(chat => (
            <div
              key={chat.id}
              onClick={() => setActiveChat(chat.id)}
              style={{
                padding: sidebarCollapsed ? '12px 8px' : '12px',
                marginBottom: '5px',
                background: activeChat === chat.id ? '#3d3d3d' : 'transparent',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                if (activeChat !== chat.id) e.currentTarget.style.background = '#353535';
              }}
              onMouseLeave={(e) => {
                if (activeChat !== chat.id) e.currentTarget.style.background = 'transparent';
              }}
            >
              <FiMessageSquare size={18} style={{ flexShrink: 0, color: '#b0b0b0' }} />
              {!sidebarCollapsed && (
                <>
                  <span style={{ 
                    flex: 1, 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis', 
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    color: '#e0e0e0'
                  }}>
                    {chat.title}
                  </span>
                  {chats.length > 1 && (
                    <button
                      className="btn btn-sm btn-link p-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteChat(chat.id);
                      }}
                      style={{ color: '#8d8d8d' }}
                    >
                      <FiTrash2 size={14} />
                    </button>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Header/Navbar */}
        <div 
          style={{
            padding: '12px 20px',
            background: '#2d2d2d',
            borderBottom: '1px solid #3d3d3d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <h5 style={{ margin: 0, fontWeight: 600, color: '#e0e0e0', fontSize: '18px' }}>
            AI Topic Generator
          </h5>
          
          <div style={{ position: 'relative' }}>
            {user ? (
              <>
                <div 
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px', 
                    cursor: 'pointer',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    background: showProfileMenu ? '#3d3d3d' : 'transparent',
                    transition: 'background 0.2s'
                  }}
                >
                  <img 
                    src={user.picture} 
                    alt={user.name}
                    style={{ 
                      width: '32px', 
                      height: '32px', 
                      borderRadius: '50%',
                      border: '2px solid #ff6b35'
                    }}
                  />
                  <span style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: '500' }}>
                    {user.name}
                  </span>
                </div>
                
                {showProfileMenu && (
                  <div style={{
                    position: 'absolute',
                    right: 0,
                    top: '50px',
                    background: '#2d2d2d',
                    border: '1px solid #3d3d3d',
                    borderRadius: '12px',
                    padding: '15px',
                    minWidth: '240px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
                    zIndex: 1000
                  }}>
                    <div style={{ 
                      padding: '10px', 
                      borderBottom: '1px solid #3d3d3d',
                      marginBottom: '10px'
                    }}>
                      <div style={{ 
                        color: '#e0e0e0', 
                        fontWeight: 'bold',
                        fontSize: '16px',
                        marginBottom: '5px'
                      }}>
                        {user.name}
                      </div>
                      <div style={{ color: '#8d8d8d', fontSize: '13px' }}>
                        {user.email}
                      </div>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="btn w-100 text-start"
                      style={{ 
                        color: '#00956eff', 
                        background: 'transparent',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '10px',
                        borderRadius: '8px',
                        transition: 'background 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#3d3d3d'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                    >
                      <FiLogOut size={18} />
                      <span>Logout</span>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <button
                onClick={handleGoogleLogin}
                className="btn"
                style={{
                  background: '#ff6b35',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontWeight: '500',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#ff7f50'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#ff6b35'}
              >
                <FiUser size={18} />
                Login with Google
              </button>
            )}
          </div>
        </div>

        {/* Chat Messages */}
        <div 
          style={{ 
            flex: 1, 
            overflowY: 'auto', 
            padding: '40px 20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {!user ? (
            <div style={{ 
              maxWidth: '600px',
              textAlign: 'center',
              marginTop: '100px'
            }}>
              <div style={{ 
                fontSize: '64px',
                marginBottom: '20px'
              }}>
                ✨
              </div>
              <h2 style={{ 
                color: '#e0e0e0', 
                marginBottom: '15px',
                fontSize: '32px',
                fontWeight: '600'
              }}>
                Welcome to AI Topic Generator
              </h2>
              <p style={{ 
                color: '#8d8d8d', 
                marginBottom: '30px',
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                Sign in with your Google account to start generating amazing topics and get AI-powered suggestions
              </p>
              <button
                onClick={handleGoogleLogin}
                className="btn btn-lg"
                style={{
                  background: '#ff6b35',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '14px 36px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#ff7f50';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ff6b35';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <FiUser size={20} />
                Sign in with Google
              </button>
            </div>
          ) : currentChat?.messages.length === 0 ? (
            <div style={{ 
              maxWidth: '700px',
              width: '100%',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '54px',
                marginBottom: '20px'
              }}>
                ✨
              </div>
              <h2 style={{ 
                color: '#e0e0e0', 
                marginBottom: '10px',
                fontSize: '36px',
                fontWeight: '600'
              }}>
                What's new, {userName}?
              </h2>
              <p style={{ 
                color: '#8d8d8d', 
                marginBottom: '40px', 
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                Ask me to generate topics on any subject you're interested in
              </p>
              
              {/* Quick Actions */}
              <div style={{ 
                display: 'flex', 
                gap: '12px', 
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginTop: '40px'
              }}>
                {quickActions.map((action, idx) => (
                  <button
                    key={idx}
                    className="btn"
                    onClick={() => setInputMessage(`Generate topics about ${action.label.toLowerCase()}`)}
                    style={{
                      background: '#3d3d3d',
                      color: '#e0e0e0',
                      border: `2px solid ${action.color}`,
                      borderRadius: '24px',
                      padding: '12px 24px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      transition: 'all 0.2s',
                      fontSize: '15px',
                      fontWeight: '500'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = action.color;
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = `0 8px 16px ${action.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#3d3d3d';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {action.icon}
                    {action.label}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: '900px', width: '100%' }}>
              {currentChat?.messages.map(message => (
                <div
                  key={message.id}
                  style={{
                    display: 'flex',
                    gap: '16px',
                    padding: '24px',
                    marginBottom: '16px',
                    background: message.sender === 'user' ? '#2d2d2d' : '#3d3d3d',
                    borderRadius: '16px',
                    border: '1px solid #4d4d4d'
                  }}
                >
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: message.sender === 'user' ? '#ff6b35' : '#4ecdc4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    flexShrink: 0,
                    fontWeight: 'bold',
                    fontSize: '16px'
                  }}>
                    {message.sender === 'user' ? user.name.charAt(0).toUpperCase() : 'AI'}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ 
                      margin: 0, 
                      lineHeight: '1.7', 
                      color: '#e0e0e0', 
                      whiteSpace: 'pre-line',
                      fontSize: '15px'
                    }}>
                      {message.text}
                    </p>
                  </div>
                </div>
              ))}
              {isTyping && (
                <div style={{
                  display: 'flex',
                  gap: '16px',
                  padding: '24px',
                  background: '#3d3d3d',
                  borderRadius: '16px',
                  border: '1px solid #4d4d4d'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: '#4ecdc4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    flexShrink: 0,
                    fontWeight: 'bold'
                  }}>
                    AI
                  </div>
                  <div style={{ flex: 1, color: '#b0b0b0' }}>
                    <span>Generating topics...</span>
                  </div>
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>
          )}
        </div>

        {/* Input Area */}
        {user && (
          <div style={{ 
            padding: '20px', 
            background: '#2d2d2d', 
            borderTop: '1px solid #3d3d3d' 
          }}>
            <div style={{ 
              maxWidth: '900px', 
              margin: '0 auto',
              background: '#1a1a1a',
              borderRadius: '16px',
              border: '2px solid #3d3d3d',
              padding: '12px 16px',
              display: 'flex',
              alignItems: 'flex-end',
              gap: '12px'
            }}>
              <textarea
                className="form-control"
                placeholder="How can I help you today?"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                rows={1}
                style={{ 
                  resize: 'none',
                  minHeight: '24px',
                  maxHeight: '150px',
                  background: 'transparent',
                  border: 'none',
                  color: '#e0e0e0',
                  outline: 'none',
                  fontSize: '15px',
                  padding: '8px 0'
                }}
              />
              <button 
                className="btn"
                onClick={sendMessage}
                disabled={!inputMessage.trim() || isTyping}
                style={{
                  background: inputMessage.trim() && !isTyping ? '#ff6b35' : '#3d3d3d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: inputMessage.trim() && !isTyping ? 'pointer' : 'not-allowed',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (inputMessage.trim() && !isTyping) {
                    e.currentTarget.style.background = '#ff7f50';
                  }
                }}
                onMouseLeave={(e) => {
                  if (inputMessage.trim() && !isTyping) {
                    e.currentTarget.style.background = '#ff6b35';
                  }
                }}
              >
                <FiSend size={18} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AITopicGenerator;